import React, { useMemo } from 'react';
import { useApprovals, type Approval } from '../../approvals/useData';
import { StatCounterGrid } from './shared';
import type { StatCounterItem } from './shared';

function isOverdue(approval: Approval, now: number): boolean {
  return (approval.steps ?? []).some(
    (step) =>
      step.status === 'PENDING' &&
      step.dueAt != null &&
      new Date(step.dueAt).getTime() < now,
  );
}

const ApprovalsInboxCounters: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const { total: mineTotal, isLoading: mineLoading } = useApprovals('mine', 1);
  const { total: submittedTotal, isLoading: submittedLoading } = useApprovals('submitted', 1);
  const { data: pendingData, isLoading: pendingLoading } = useApprovals('mine', 1, '', {
    status: 'PENDING',
  });

  const overdueCount = useMemo(() => {
    const now = Date.now();
    return (pendingData ?? []).filter((a) => isOverdue(a, now)).length;
  }, [pendingData]);

  const isLoading = mineLoading || submittedLoading || pendingLoading;

  const counters: StatCounterItem[] = [
    {
      key: 'mine',
      label: 'My pending',
      value: mineTotal ?? 0,
      href: '/approvals',
      accent: 'bg-amber-500',
    },
    {
      key: 'submitted',
      label: 'Submitted',
      value: submittedTotal ?? 0,
      href: '/approvals',
      accent: 'bg-sky-500',
    },
    {
      key: 'overdue',
      label: 'Overdue',
      value: overdueCount,
      href: '/approvals',
      accent: 'bg-rose-500',
    },
  ];

  return (
    <StatCounterGrid
      title="Approvals · Inbox"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/approvals"
    />
  );
};

export default ApprovalsInboxCounters;
